// extracted by mini-css-extract-plugin
export var dataRow = "component-module--dataRow--7c91b";
export var formUnitSystemBlock = "component-module--formUnitSystemBlock--af9db";